import React from "react";

import LearnerClassroomTabbedLayout from "../../layout/LearnerClassroomTabbedLayout";
import LearnerClassroomV2Layout from "../../layout/LearnerClassroomV2Layout";
import {
  LearnerClassroomProvider,
  useLearnerClassroomContext,
} from "../../providers/LearnerClassroomProvider";
import { isLearnerClassroomV2Layout } from "./layoutPredicates";

/** Picks V2 (no-tab) or V1 (tabbed) layout based on context. */
const LearnerClassroomLayoutSwitch = () => {
  const { activity, syllabus, section } = useLearnerClassroomContext();

  if (isLearnerClassroomV2Layout(section, syllabus, activity)) {
    return <LearnerClassroomV2Layout />;
  }

  return <LearnerClassroomTabbedLayout />;
};

interface LearnerClassroomProps {
  sectionUid: string;
}

const LearnerClassroom = ({ sectionUid }: LearnerClassroomProps) => {
  return (
    <LearnerClassroomProvider sectionUid={sectionUid}>
      <LearnerClassroomLayoutSwitch />
    </LearnerClassroomProvider>
  );
};

export default React.memo(LearnerClassroom);
